<script setup lang="ts">
import Icon from '../Icon.vue';

const props = defineProps<{
	description?: string;
	icon?: string;
}>();
</script>

<template>
	<div class="bottom-dialog-notification">
		<div class="bottom-dialog-notification__main" aria-live="polite">
			<Icon :name="props.icon" v-if="props.icon" />
			<div class="bottom-dialog-notification__content" v-if="props.description">
				<p id="bottom-dialog-notification-description">
					{{ props.description }}
				</p>
			</div>
		</div>
		<div class="bottom-dialog-notification__actions" v-if="$slots.actions">
			<slot name="actions" />
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.bottom-dialog-notification
	{
		@include flex(null, null, var(--spacing-md));
		flex-direction:column;

		@include responsive(md)
		{
			gap:var(--spacing-lg);
			align-items:center;
			flex-direction:row;
		}

		&__main
		{
			@include flex(null, start, var(--spacing-2xs));
			color:var(--c-body);

			.icon
			{
				@include svg(32);
			}
		}
		&__content
		{
			@include text-caption;
		}
		&__actions
		{
			flex-shrink:0;
			@include flex(null, center, var(--spacing-2xs));
		}
	}
}
</style>
